import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';

import type { Country } from '../../features/geography/types';
import { ErrorMessage } from '../ErrorMessage/ErrorMessage';

import styles from './CountrySelect.module.scss';
import { Option } from './Option/Option';
import { Placeholder } from './Placeholder/Placeholder';
import { SingleValue } from './SingleValue/SingleValue';

export function CountrySelect(props: {
  value?: Country | null;
  onChange: (value: Country | null) => void;
  options: Country[];
  disabled?: boolean;
  name?: string;
  errorMessage?: string | null;
}) {
  const { t } = useTranslation();
  return (
    <>
      <div className={styles.wrapper}>
        <Select
          hideSelectedOptions
          classNames={{
            container: () => styles.container,
            control: (selectState) =>
              classNames(styles.control, {
                [styles.openMenuControl]: selectState.menuIsOpen,
              }),
            valueContainer: () => styles.valueContainer,
            menu: () => styles.menu,
            menuList: () => styles.menuList,
          }}
          components={{
            Option,
            SingleValue,
            Placeholder,
            IndicatorSeparator: () => null,
          }}
          getOptionLabel={(option) => option.name}
          getOptionValue={(option) => option.code}
          isClearable={false}
          isDisabled={props.disabled}
          isSearchable={false}
          name={props.name}
          options={props.options}
          placeholder={t('forms.selectCountry')}
          value={props.value}
          onChange={props.onChange}
        />
      </div>
      <ErrorMessage>{props.errorMessage}</ErrorMessage>
    </>
  );
}
